/* src/app/builder-screen-beta/event-scripting/event-script-editor.component.scss */
.event-editor-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.mode-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #d9d9d9;
  background-color: #fafafa;
  margin: -24px -24px 0 -24px;
}
.mode-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}
.drawer-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid #d9d9d9;
  background-color: #fafafa;
  margin: 0 -24px -24px -24px;
}
/*# sourceMappingURL=event-script-editor.component.css.map */
